// extracted by mini-css-extract-plugin
export default {"rating":"rK-z","numberOfStars":"sK-z","count":"tK-z","barGraphSpacing":"uK-z","barGraph":"vK-z"};